module.exports = __webpack_public_path__ + "img/performance-active.9243389a.svg";